import taxiTaxiContractValidationService from "../common/taxi-taxi-contract-validation.service";

const taxiTaxiContractEditFormValidationService = {
  validateActivity: taxiTaxiContractValidationService.validateActivity,
  validateDisplayName: taxiTaxiContractValidationService.validateDisplayName,
  validatePriority: taxiTaxiContractValidationService.validatePriority,
};

export default taxiTaxiContractEditFormValidationService;
